"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIME_ZONES = exports.DEFAULT_TIME_ZONE = void 0;
/**
 * テナントのタイムゾーン設定（IANA Timezone）のデフォルト値。
 * 既存テナントは全てこの値として扱うため、日本語UIの表示は変わらない。
 */
exports.DEFAULT_TIME_ZONE = "Asia/Tokyo";
/**
 * テナント設定で選択できるタイムゾーン（IANA Timezone）の一覧。
 * 現在および今後の顧客で必要なものに絞っている。必要になった時点で追加する。
 */
exports.TIME_ZONES = [
    { value: "Asia/Tokyo", label: "Asia/Tokyo (Japan)" },
    { value: "Asia/Seoul", label: "Asia/Seoul (Korea)" },
    { value: "Asia/Shanghai", label: "Asia/Shanghai (China)" },
    { value: "Asia/Hong_Kong", label: "Asia/Hong_Kong" },
    { value: "Asia/Singapore", label: "Asia/Singapore" },
    { value: "Asia/Bangkok", label: "Asia/Bangkok (Thailand)" },
    { value: "Asia/Kolkata", label: "Asia/Kolkata (India)" },
    { value: "Asia/Dubai", label: "Asia/Dubai" },
    { value: "Australia/Sydney", label: "Australia/Sydney" },
    { value: "Europe/London", label: "Europe/London (UK)" },
    { value: "Europe/Paris", label: "Europe/Paris" },
    { value: "Europe/Berlin", label: "Europe/Berlin" },
    { value: "America/New_York", label: "America/New_York (US Eastern)" },
    { value: "America/Chicago", label: "America/Chicago (US Central)" },
    { value: "America/Denver", label: "America/Denver (US Mountain)" },
    { value: "America/Los_Angeles", label: "America/Los_Angeles (US Pacific)" },
    { value: "UTC", label: "UTC" },
];
